var _defs, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeatCarbonAlarm = function SvgFeatCarbonAlarm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.28 15.27",
    width: 15.28,
    height: 15.27,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs191"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style182"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "g186",
    transform: "translate(-0.61,-0.33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 13.1,0.43 c 1.44,0 2.63,1.13 2.69,2.57 v 9.81 c 0,1.44 -1.13,2.63 -2.57,2.69 H 3.4 C 1.96,15.5 0.77,14.37 0.71,12.93 V 3.12 C 0.71,1.68 1.84,0.49 3.28,0.43 H 3.4 Z m 0,1.08 H 3.4 c -0.86,0 -1.56,0.66 -1.62,1.52 v 9.79 c 0,0.86 0.66,1.56 1.52,1.62 h 9.79 c 0.86,0 1.56,-0.66 1.62,-1.52 V 3.12 C 14.71,2.26 14.05,1.56 13.19,1.5 H 13.1 Z M 5.61,8.5 c 0.22,1.06 1.04,1.88 2.1,2.1 v 1.09 C 6.06,11.45 4.76,10.15 4.52,8.5 Z m 5.28,0 h 1.09 c -0.24,1.65 -1.54,2.95 -3.19,3.19 V 10.6 c 1.06,-0.21 1.88,-1.04 2.1,-2.1 z M 8.25,6.35 c 0.89,0 1.62,0.72 1.62,1.62 0,0.9 -0.73,1.61 -1.62,1.61 -0.89,0 -1.61,-0.72 -1.61,-1.61 0,-0.89 0.72,-1.62 1.61,-1.62 z m 0,1.08 c -0.3,0 -0.54,0.24 -0.54,0.54 0,0.3 0.24,0.53 0.54,0.53 0.3,0 0.54,-0.24 0.54,-0.54 0,-0.3 -0.24,-0.53 -0.54,-0.53 z m 0.54,-3.2 c 1.65,0.24 2.95,1.54 3.19,3.19 H 10.89 C 10.67,6.36 9.85,5.54 8.79,5.32 Z m -1.08,0 V 5.32 C 6.65,5.54 5.83,6.36 5.61,7.42 H 4.52 C 4.76,5.77 6.06,4.47 7.71,4.23 Z m 4.31,-0.57 c 0.3,0 0.54,0.24 0.54,0.54 0,0.3 -0.24,0.54 -0.54,0.54 -0.3,0 -0.54,-0.24 -0.54,-0.54 0,-0.3 0.24,-0.54 0.54,-0.54 z",
    id: "path184",
    style: {
      fill: "#7f7f7f",
      fillOpacity: 1,
      stroke: "#7f7f7f",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })));
};
export default SvgFeatCarbonAlarm;